import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class WhatsInside extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Updates What's inside content when the selected variant changes.
   * @param {CustomEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newBlock = html.querySelector(`whats-inside.whats-inside--${this.#blockId}`);
        if (!newBlock) return;

        morph(this, newBlock, { childrenOnly: true });
        this.hidden = newBlock.hasAttribute('hidden');
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[whats-inside] Event promise rejected:', error);
      });
  };

  get #blockId() {
    const match = this.className.match(/whats-inside--([^\s]+)/);
    return match?.[1] ?? '';
  }
}

if (!customElements.get('whats-inside')) {
  customElements.define('whats-inside', WhatsInside);
}
